import StService from './StService';
import { createApi } from '@stilingue/st-auth-utils';
import { featureFlagFlags } from '@/plugins/rollout';
import { isProdVersion } from '@stilingue/st-environment-controller-utils';
import { getPasskey } from './passkeyUtils';
import gateway from './Gateway';

const version = isProdVersion()
  ? featureFlagFlags.RoutingServiceVersionProd.getValue()
  : featureFlagFlags.RoutingServiceVersionStaging.getValue();

const afterParser = response => response.data;
const passkey = getPasskey();

class RoutingService extends StService {
  constructor(gateway, version) {
    const api = createApi(`sac-router/${version}/`, gateway);
    super(api, { afterParser });
  }

  getRoutes(params = {}) {
    params.passkey = passkey;
    return this.api.get({ params, url: 'router/setting' }).then(this.afterParser);
  }

  getRouterSettings(routingId = '', params = {}) {
    params.passkey = passkey;
    return this.api.get({ params, url: `router/setting/${routingId}` }).then(this.afterParser);
  }

  getUserStatusHistory(params = {}) {
    const { userId, accountId, universeId, period } = params;

    return this.api.get({
      params: period ? { passkey, period } : { passkey },
      url: `accounts/${accountId}/universes/${universeId}/router/users/${userId}/statuses`
    }).then(this.afterParser);
  }
}

export default new RoutingService(gateway, version);
